// extracted by mini-css-extract-plugin
export default {"contactBar":"candlebar_contactBar__p4j5L","link":"candlebar_link__iPJxX"};